<template>
  <div class="subject_warp">
    <div class="form">
      <div class="date">
        <span>
          学生总得分率统计
        </span>
        <div class="grade">
          <el-select style="width:110px"
                     v-model="graduated_id"
                     @change="getClassList"
                     clearable
                     filterable
                     placeholder="届">
            <el-option v-for="item in $parent.jieList"
                       :key="item.graduated_id"
                       :label="item.year_desc"
                       :value="item.graduated_id">
            </el-option>
          </el-select>
        </div>

        <div class="class">
          <el-select style="width:110px"
                     v-model="class_id"
                     @change="classChange"
                     clearable
                     filterable
                     placeholder="班级">
            <el-option v-for="item in classList"
                       :key="item.id"
                       :label="item.class_name"
                       :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="chechSubject">
          <el-select style="width:110px"
                     v-model="subject_id"
                     @change="clear"
                     clearable
                     placeholder="科目">
            <el-option v-for="item in subjectList"
                       :key="item.subject_id + ''"
                       :label="item.subject_name"
                       :value="item.subject_id + ''">
            </el-option>
          </el-select>
        </div>
      </div>

      <div class="subject">
        <span class="subject_list"
              style="margin:10px 0;">
          <span :class="{'item':true,'isActive':item.subject_id == subject_id}"
                @click="clickItem(item.subject_id)"
                v-for="item in subjectList"
                :key="item.subject_id">{{item.subject_name}}</span>
        </span>
      </div>
    </div>
    <div id="myChart"
         :style="{width: '100%', height: '40vh'}"></div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      teacher: '',
      subject_id: '',
      graduated_id: '',
      class_id: '',
      list: [],
      classList: [],
      subjectList: []
    }
  },
  mounted () {
    // this.getHomeSubject()
  },
  methods: {
    classChange () {
      this.subject_id = ''
      this.getHomeSubject()
    },
    getHomeSubject () {
      this.$http({
        url: '/api/v1/main/home_subject',
        method: 'get',
        params: {
          class_id: this.class_id
        }
      }).then(res => {
        this.subjectList = res.data.list
        this.subject_id = res.data.list[0].subject_id + ''
        this.clear()
      })
    },
    clear () {
      let myChart = this.$echarts.init(document.getElementById('myChart'))
      myChart.dispose()
      this.getRuoDian()
    },
    drawLine () {
      var myChart = this.$echarts.init(document.getElementById('myChart'));
      // 绘制图表
      myChart.setOption({
        xAxis: {
          type: 'category',
          data: this.label
        },
        dataZoom: {
          type: "slider",
          show: true
        },
        grid: {
          bottom: '20%',
          top: '10%',
          right: '5%'
        },
        yAxis: {
          type: 'value',
          max: 100,
          min: 0
        },
        color: ['#3F9EFF'],
        series: [
          {
            data: this.value,
            type: 'bar'
          }
        ]
      })
    },
    getClassList () {
      this.class_id = ''
      this.classList = []
      if (this.graduated_id == '') return
      this.$http({
        url: '/api/v1/special/get_class',
        method: 'get',
        params: {
          school_id: this.$parent.school_id,
          graduated_id: this.graduated_id
        }
      }).then(res => {
        this.classList = res.data.list
        this.clear()
      })
    },
    getRuoDian () {
      let params = {
        school_id: this.$parent.school_id,
        graduated_id: this.graduated_id,
        class_id: this.class_id,
        subject_id: this.subject_id
      }
      this.$http({
        url: '/api/v1/main/get_user_weak_point',
        method: 'get',
        params
      }).then(res => {
        this.list = res.data.list
        let label = []
        let value = []
        this.list.forEach(item => {
          label.push(`${item.start_time}~${item.end_time}`)
          value.push(Number(item.score))
        })
        this.value = value
        this.label = label
        this.$nextTick(() => {
          this.drawLine()
        })
      })
    },
    clickItem (id) {
      if (this.subject_id == id) {
        this.subject_id = ''
        this.clear()

        return
      }
      this.subject_id = id
      this.clear()
    }
  }
}
</script>

<style lang="scss" scoped>
@media screen and (min-width: 1200px) {
  .isActive {
    border: 1px solid #3f9eff !important;
    color: #3f9eff !important;
  }
  .subject_warp {
    background: white;
    padding: 10px;
    margin: 1%;
  }
  .subject_list {
    border: 1px solid #d9d9d9;
    display: inline-block;
    span {
      display: inline-block;
      border-right: 1px solid #d9d9d9;
      padding: 5px 10px;
      cursor: pointer;
      color: #000000;
    }
  }
  .form {
    display: flex;
    .date {
      flex: 1;
      span {
        width: 120px;
        font-weight: bold;
        color: rgba(8, 8, 8, 0.85);
        font-size: 16px;
      }
      div {
        display: inline-block;
        width: 110px;
        margin-right: 10px;
      }
    }
    .subject {
      display: flex;
    }
  }

  .chechSubject {
    display: none !important;
  }
}

@media screen and (max-width: 1200px) {
  .subject_warp {
    background: white;
    padding: 5px 10px;
    border-radius: 5px;
    margin: 1%;
    .form {
      .date {
        display: flex;
        align-items: center;
        position: relative;
        span {
          display: inline-block;
          width: 130px;
          font-size: 16px;
          font-weight: bold;
          color: rgba(8, 8, 8, 0.85);
          margin-right: 5px;
        }
        .el-select {
          width: 80px !important;
        }
        .grade {
          margin-left: 10px;
        }
        .class {
          margin-left: 10px;
        }
        .chechSubject {
          position: absolute;
          right: 14px;
        }
      }
    }
  }
  .subject {
    display: none;
  }
}
</style>